// @flow

/**
 * Module dependencies.
 */

import { breakpoints } from 'client/styles/layout';

/**
 * Font families.
 */

const fontFamily = {
  montserrat: '"Montserrat", sans-serif',
  openSans: '"Open Sans", sans-serif',
  poppins: '"Poppins", sans-serif'
};

/**
 * Base styles.
 */

const fontSizeBase = '15px';
const lineHeightBase = '24px';

/**
 * Export `h1`.
 */

export const h1 = `
  font-family: ${fontFamily.poppins};
  font-size: 47px;
  font-weight: 600;
  letter-spacing: -0.6px;
  line-height: 64px;

  b {
    font-weight: 700;
  }


  @media (max-width: ${breakpoints.xs}px) {
    font-size: 42px;
    line-height: 52px;
  }
`;

/**
 * Export `h2`.
 */

export const h2 = `
  font-family: ${fontFamily.montserrat};
  font-size: 36px;
  font-weight: 400;
  letter-spacing: -0.3px;
  line-height: 48px;

  b {
    font-weight: 500;
  }

  @media (max-width: ${breakpoints.xs}px) {
    font-size: 28px;
    line-height: 40px;
  }
`;

/**
 * Export `h3`.
 */

export const h3 = `
  font-size: 27px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 40px;

  b {
    font-weight: 400;
  }

  @media (max-width: ${breakpoints.xs}px) {
    font-size: 24px;
    line-height: 36px;
  }
`;

/**
 * Export `h4`.
 */

export const h4 = `
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 32px;

  b {
    font-weight: 500;
  }
`;

/**
 * Export `paragraph`.
 */

export const paragraph = `
  font-size: ${fontSizeBase};
  letter-spacing: 0;
  line-height: 24px;
`;

/**
 * Export `small`.
 */

export const small = `
  font-size: 11px;
  letter-spacing: 0;
  line-height: ${lineHeightBase};
`;

/**
 * Export `type`.
 */

export const type = {
  fontFamily,
  fontSizeBase,
  lineHeightBase
};



// WEBPACK FOOTER //
// ../src/client/styles/type.js